export default __webpack_public_path__ + "static/full_logo_color-c9a2bd8f1c7017c72c0270d7bad99b54.svg";